import { DiagramEngine, DiagramWidget, DiagramModel } from 'mrblenny-storm-react-diagrams'
import { forEach, values } from 'lodash'
import React from 'react'
import sLay from 'styles/modules/layout.scss'
import './Flow.global.scss'
import s from './Flow.scss'
import cn from 'classnames'
import { CustomNodeFactory } from './CustomNode/CustomNodeFactory'
import { SimplePortFactory } from './CustomNode/SimplePortFactory'
import { CustomPortModel } from './CustomNode/CustomPortModel'
import Tray from './Tray'
import DropLayer from './DropLayer'
import EmptyMessage from './EmptyMessage'
import { nodes } from './Flow.data'

export default class Flow extends React.Component {
  constructor(props) {
    super(props)
    const { flow } = this.props

    const engine = new DiagramEngine()
    engine.installDefaultFactories()
    engine.registerPortFactory(
      new SimplePortFactory('input', () => new CustomPortModel('input', 'input'))
    )
    engine.registerPortFactory(
      new SimplePortFactory('output', () => new CustomPortModel('input', 'output'))
    )
    Object.keys(nodes).map(nodeType =>
      engine.registerNodeFactory(new CustomNodeFactory(flow, nodeType))
    )

    const model = new DiagramModel()
    model.deSerializeDiagram(flow, engine)
    engine.setDiagramModel(model)

    this.state = {
      engine,
      model,
    }
  }
  addNode = node => {
    this.state.model.addNode(node)
    this.selectNode(node)
  }
  saveFlow = flowData => {
    const newModelSerialized = this.state.model.serializeDiagram()
    return this.props.saveFlow({
      ...flowData,
      ...newModelSerialized,
    })
  }
  publishFlow = flowData => {
    const newModelSerialized = this.state.model.serializeDiagram()
    return this.props.publishFlow({
      ...flowData,
      ...newModelSerialized,
    })
  }
  saveNode = (node, { extras }) => {
    const { submit, flow } = this.props
    // Mutate the node
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.model.nodes[node.id].extras = extras
    this.forceUpdate()
    // Deselect the node we just saved
    this.selectNode(undefined)
    // Save the flow (timeout will wait for the form to be mounted)
    setTimeout(() => submit(`flow-${flow.id}`), 1)
  }
  selectNode = node => this.setState({ selected: node })
  addListeners = model => {
    forEach(model.nodes, item => {
      // Add selection listener
      const hasSelectionListener = values(item.listeners).some(
        listener => listener.selectionChanged
      )
      if (!hasSelectionListener) {
        item.addListener({ selectionChanged: this.onSelectionChange })
      }

      // Add remove listener
      const hasRemoveListener = values(item.listeners).some(
        listener => listener.entityRemoved === this.onEntityRemoved
      )
      if (!hasRemoveListener) {
        item.addListener({ entityRemoved: this.onEntityRemoved })
      }
    })
  }
  onSelectionChange = node => {
    if (node.isSelected) {
      this.selectNode(node.entity)
    } else {
      this.selectNode(undefined)
    }
  }
  onEntityRemoved = () => {
    this.selectNode(undefined)
  }
  render() {
    const { flow, savePending, publishPending, confirmDeleteFlow } = this.props
    const { engine, model, selected } = this.state
    this.addListeners(model)

    return (
      <div className={cn(sLay.flex, sLay['layout-column'])} style={{ position: 'relative' }}>
        <DropLayer addNode={this.addNode} diagramEngine={engine}>
          <DiagramWidget
            allowLooseLinks={false}
            diagramEngine={engine}
            className={s.flow}
            maxNumberPointsPerLink={0}
            deleteKeys={[46]} // Delete
          />
          {Object.keys(model.nodes).length === 0 && <EmptyMessage />}
        </DropLayer>
        <Tray
          flow={flow}
          model={model}
          selected={selected}
          saveFlow={this.saveFlow}
          publishFlow={this.publishFlow}
          saveNode={this.saveNode}
          deleteFlow={confirmDeleteFlow}
          savePending={savePending}
          publishPending={publishPending}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Flow.jsx